import React, {Suspense} from 'react';
import {Switch, Route, useLocation, useRouteMatch} from "react-router-dom";
import ErrorBoundary2 from './ErrorBoundary2';
import './App.scss';
import ViewTerms from "./ViewTerms";
import Footer from "./components/footer";
import {appConfig} from "./appconfig";

type myProps = { config: appConfig };

function App({config}: myProps) {
    const location = useLocation();
    const search = new URLSearchParams(location.search);

    // Raw / printer-friendly terms view (no chrome)
    if (location.pathname.startsWith("/views/terms") && search.get("raw") === 'true') {
        return (
            <Suspense fallback={<div>Please wait...</div>}>
                <div className="container fs-app-container"><ViewTerms/></div>
            </Suspense>);
    }

    const containerClass = "fs-app-container fs-bottom";

    return (
        <div>
            <ErrorBoundary2 config={config}>
                <div className="container">
                    <div className={containerClass}>
                        <Suspense fallback={<div>Please wait...</div>}>
                            <Switch>
                                <Route path={["/views/terms/:app", "/views/terms"]}>
                                    <ViewTerms/>
                                </Route>
                            </Switch>
                        </Suspense>
                    </div>
                </div>
                <Footer/>
            </ErrorBoundary2>
        </div>
    );
}

export default App;
